// test917
(917 && 0);
